module.exports = "<p>confirm works!</p>\r\n"